<template>
    <div class="dm-default-cover-image" :class="data.css_class">
        <img :src="data.image_url" :alt="data.title" />
        <div class="dm-cover-text-container">
            <div class="dm-cover-text-modern">
                <div class="dm-cover-title">{{ data.title }}</div>
                <div class="dm-cover-author">{{ data.author_name }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["data"],
};
</script>
